import clsx from "clsx";

const Pill = ({
  text,
  type = "normal",
}: {
  text: string;
  type?: "normal" | "warning" | "success";
}) => {
  return (
    <div
      className={clsx(
        "inline-block rounded-xl border px-2 py-0.5 text-2xs uppercase",
        {
          "border-gray": type === "normal",
          "border-red": type === "warning",
          "border-green": type === "success",
        },
      )}
    >
      {text}
    </div>
  );
};

export default Pill;
